module.exports = __webpack_public_path__ + "e4452bde7e2582df5934d464d89f0a9e.MP3";